// attempting to bring back ducks (see: https://github.com/erikras/ducks-modular-redux)
import { combineActions, createAction, handleActions } from 'redux-actions';

import { AMP_FILTER_OPTIONS } from './const';

// actions
const AMP_QUERY_BY_ASSET_ID_FAILED = 'amp/AMP_QUERY_BY_ASSET_ID_FAILED';
const AMP_QUERY_BY_ASSET_ID_FULFILLED = 'amp/AMP_QUERY_BY_ASSET_ID_FULFILLED';
const AMP_QUERY_BY_ASSET_ID_REQUESTED = 'amp/AMP_QUERY_BY_ASSET_ID_REQUESTED';
const AMP_QUERY_BY_WORKFRONT_ID_FAILED = 'amp/AMP_QUERY_BY_WORKFRONT_ID_FAILED';
const AMP_QUERY_BY_WORKFRONT_ID_FULFILLED = 'amp/AMP_QUERY_BY_WORKFRONT_ID_FULFILLED';
const AMP_QUERY_BY_WORKFRONT_ID_REQUESTED = 'amp/AMP_QUERY_BY_WORKFRONT_ID_REQUESTED';
const AMP_QUERY_DATA_CLEARED = 'amp/AMP_QUERY_DATA_CLEARED';
const AMP_QUERY_DATA_FILTER_CHANGED = 'amp/AMP_QUERY_DATA_FILTER_CHANGED';

// action creators
export const changeQueryDataFilter = createAction(AMP_QUERY_DATA_FILTER_CHANGED);
export const clearQueryData = createAction(AMP_QUERY_DATA_CLEARED);
export const queryByAssetId = createAction(AMP_QUERY_BY_ASSET_ID_REQUESTED);
export const queryByAssetIdFailed = createAction(AMP_QUERY_BY_ASSET_ID_FAILED);
export const queryByAssetIdFulfilled = createAction(AMP_QUERY_BY_ASSET_ID_FULFILLED);
export const queryByWorkfrontId = createAction(AMP_QUERY_BY_WORKFRONT_ID_REQUESTED);
export const queryByWorkfrontIdFailed = createAction(AMP_QUERY_BY_WORKFRONT_ID_FAILED);
export const queryByWorkfrontIdFulfilled = createAction(AMP_QUERY_BY_WORKFRONT_ID_FULFILLED);

// default state
export const DEFAULT_STATE = {
  filter: AMP_FILTER_OPTIONS[0],
  isFetching: false,
  payload: []
};

// set `isFetching` to true
const requestActions = combineActions(
  AMP_QUERY_BY_ASSET_ID_REQUESTED,
  AMP_QUERY_BY_WORKFRONT_ID_REQUESTED
);

// reset to default state
const resetActions = combineActions(
  AMP_QUERY_BY_ASSET_ID_FAILED,
  AMP_QUERY_BY_WORKFRONT_ID_FAILED,
  AMP_QUERY_DATA_CLEARED
);

// save action payload as `payload`
const savePayloadActions = combineActions(
  AMP_QUERY_BY_ASSET_ID_FULFILLED,
  AMP_QUERY_BY_WORKFRONT_ID_FULFILLED
);

// reducer
export default handleActions(
  {
    [requestActions]: state => ({ ...state, isFetching: true }),
    [resetActions]: () => DEFAULT_STATE,
    [savePayloadActions]: (state, { payload }) => ({
      ...state,
      payload,
      isFetching: false
    }),

    // save action payload as `filter`
    [AMP_QUERY_DATA_FILTER_CHANGED]: (state, { payload: filter }) => ({ ...state, filter })
  },
  DEFAULT_STATE
);
